interface Images {
  (): {
    images: __WebpackModuleApi.RequireContext
  }
}

export const useImagesContext: Images = () => ({
  images: require.context('../assets/images', true),
})
